import { axiosGet } from '@/api/handlers';
import { useQuery } from '@/api/hooks';

import { NotificationBadgeModel } from '../_models/notification';
import { authenticationQueryKeyMap } from '../_utils/query-keys';

export const useMyNotificationBadges = ({
  enabled = true,
  refetchIntervalInMinutes,
}: {
  enabled?: boolean;
  refetchIntervalInMinutes?: number;
}) => {
  return useQuery({
    queryKey: authenticationQueryKeyMap.myNotificationBadges(),
    queryFn: async () => {
      const res = await axiosGet('/api/notifications/badges/me/');
      return NotificationBadgeModel.parse(res);
    },
    enabled,
    refetchInterval: refetchIntervalInMinutes
      ? refetchIntervalInMinutes * 60 * 1000
      : undefined,
  });
};
